export const AP_INVOICE_STATUSES = [
  'intake',
  'needs_cleanup',
  'paid',
  'approved_by_pc',
  'operations_review',
  'finance_review',
  'payment_ready',
  'scheduled',
  'processing',
  'needs_approval',
  'wait_for_adjustment',
  'on_hold',
  'disputed',
  'duplicate',
  'superseded',
  'dismissed',
  'archived',
  'unknown',
] as const

export const AP_INVOICE_PRIORITIES = [
  'pay_now',
  'pay_this_week',
  'high',
  'low',
  'on_hold',
  'wait_on_customer',
  'not_applicable',
  'deposit_required',
  'approved_exception',
  'none',
] as const

export const AP_EXPENSE_CATEGORIES = [
  { value: 'freight_logistics', label: 'Freight / logistics' },
  { value: 'installation', label: 'Install' },
  { value: 'storage', label: 'Storage' },
  { value: 'cad_design', label: 'CAD / design' },
  { value: 'software_technology', label: 'Software / technology' },
  { value: 'professional_services', label: 'Professional services' },
  { value: 'general_project_expense', label: 'General project expense' },
  { value: 'overhead_unallocated', label: 'Overhead / unallocated' },
] as const

export const AP_PAYMENT_POLICIES = [
  { value: 'normal_terms', label: 'Normal terms' },
  { value: 'cash_in_advance', label: 'Cash in advance' },
  { value: 'prepaid_at_order', label: 'Prepaid at order' },
  { value: 'autopay', label: 'Autopay' },
  { value: 'recurring_installment', label: 'Recurring / installment' },
  { value: 'deposit_required', label: 'Deposit required' },
  { value: 'project_hold', label: 'Project hold' },
] as const

export const AP_INVOICE_REVIEW_QUEUES = [
  { key: 'new_intake', label: 'New intake' },
  { key: 'needs_cleanup', label: 'Needs cleanup' },
  { key: 'what_needs_paying', label: 'What needs paying' },
  { key: 'possible_duplicates', label: 'Possible duplicates' },
  { key: 'missing_invoice_number', label: 'Missing invoice #' },
  { key: 'missing_vendor', label: 'Missing vendor' },
  { key: 'unknown_payment_terms', label: 'Unknown payment terms' },
  { key: 'missing_attachment', label: 'Missing attachment' },
  { key: 'unlinked_po_project', label: 'Unlinked invoices' },
  { key: 'needs_approval', label: 'Needs approval' },
  { key: 'waiting_for_adjustment', label: 'Waiting for adjustment' },
  { key: 'payment_reconciliation', label: 'Payment reconciliation' },
  { key: 'vendor_credit', label: 'Vendor credit' },
  { key: 'overdue_exceptions', label: 'Overdue exceptions' },
] as const
